export type ReviewsAvailability = {
  hasReputation: boolean;
  hasGooglePlace: boolean;
  hasRedditLinks: boolean;
};

export type ReviewsEntryVariant =
  | 'web-google-reddit'
  | 'web-google'
  | 'web-reddit'
  | 'web'
  | 'google-reddit'
  | 'google'
  | 'reddit';

export const getReviewsEntryVariant = ({
  hasReputation,
  hasGooglePlace,
  hasRedditLinks,
}: ReviewsAvailability): ReviewsEntryVariant | null => {
  if (hasReputation && hasGooglePlace && hasRedditLinks) return 'web-google-reddit';
  if (hasReputation && hasGooglePlace) return 'web-google';
  if (hasReputation && hasRedditLinks) return 'web-reddit';
  if (hasReputation) return 'web';
  if (hasGooglePlace && hasRedditLinks) return 'google-reddit';
  if (hasGooglePlace) return 'google';
  if (hasRedditLinks) return 'reddit';
  return null;
};
